import { getMarketingScripts } from './Scripts/getScripts';
import { getUniversalNavigation } from './UniversalNavigation/getComponents';

export { getMarketingScripts, getUniversalNavigation };
